<script setup lang="ts">
import type SiteBanner from '@store/content/entities/SiteBanner';

const { banner } = defineProps<{
    banner?: SiteBanner;
    reserveType?: string;
    origin?: string;
    destination?: string;
    secondaryColor?: boolean;
    title?: string;
}>();

const mobileHeight = computed(
    () =>
        `${
            ((banner?.mobileHeight ?? banner?.desktopHeight ?? 550) /
                (banner?.mobileWidth ?? banner?.desktopWidth ?? 1000)) *
            90
        }vw`
);
const desktopHeight = computed(
    () =>
        `${
            ((banner?.desktopHeight ?? 550) / (banner?.desktopWidth ?? 1000)) *
            40
        }vw`
);
const maxHeight = computed(
    () =>
        `${((image.value.height ?? 500) / (image.value.width ?? 1000)) * 600}px`
);
const { isMobile } = useSize();
const image = computed(() => {
    if (isMobile.value) {
        return {
            src: banner?.mobileImageUrl ?? banner?.desktopImageUrl,
            hash: banner?.mobileBlurhash ?? banner?.desktopBlurhash,
            height: banner?.mobileHeight ?? banner?.desktopHeight,
            width: banner?.mobileWidth ?? banner?.desktopWidth,
        };
    }
    return {
        src: banner?.desktopImageUrl,
        hash: banner?.desktopBlurhash,
        height: banner?.desktopHeight,
        width: banner?.desktopWidth,
    };
});
</script>
<template>
    <div class="list-loading-container">
        <div class="list-loading-content">
            <img class="loading-image" alt="loading" :src="image.src" />
            <div
                class="footer-wrapper"
                :class="{ 'secondary-color': secondaryColor }"
            >
                <mr-dots-loading
                    :color="secondaryColor ? 'white' : 'var(--blue-400)'"
                    :size="8"
                />
                <mr-typography v-if="destination && reserveType">
                    مِستربلیط در حال یافتن بهترین {{ reserveType }}‌های
                    {{ origin || destination }}
                    {{ origin ? `به ${destination}` : '' }} برای شما می‌باشد.
                </mr-typography>
                <mr-typography v-if="title">
                    {{ title }}
                </mr-typography>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.list-loading-container {
    position: fixed;
    inset: 0 0 0 0;
    background-color: rgba($color: usePalette(), $alpha: 0.2);
    z-index: 2147483646;
    display: flex;
    align-items: center;
    justify-content: center;
    .list-loading-content {
        @include shadow-level4();
        border-radius: 16px;
        overflow: hidden;
        background-color: white;

        width: 40vw !important;
        max-width: 600px !important;
        @include mobile-only() {
            width: 90vw !important;
        }
        .footer-wrapper {
            @include tg-l();
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            padding: 0 8px;
            &.secondary-color {
                background-color: usePalette();
            }
        }

        .loading-image {
            width: 40vw !important;
            height: v-bind(desktopHeight) !important;
            object-fit: contain;
            max-width: 600px !important;
            max-height: v-bind(maxHeight) !important;
            @include mobile-only() {
                height: v-bind(mobileHeight) !important;
                width: 90vw !important;
            }
        }
    }
}
</style>
